/* 鶏雫 — 旧 ?lang=en / ?lang=ja の後方互換リダイレクト（恒久保持）。
   日英の出し分けは Shopify の言語（/en などの URL）でサーバー側が行う。
   このファイルは、広告・GBP・QR などに配布済みの ?lang= 付き URL を
   対応する言語の URL へ送り直すだけ（切り替えボタン・localStorage は使わない）。
   - ?lang=en かつ英語面でない → 英語のルート（window.tsEnRoot）へ
   - ?lang=ja かつ英語面       → 日本語のルート（window.tsJaRoot）へ
   英語が未公開（tsEnRoot が null）のときは何もしない。
   lang 以外のクエリ（gclid / utm_* など）と #アンカーは引き継ぐ。 */
(function () {
  var s = window.location.search;
  if (!s) return;
  var m = /[?&]lang=([^&#]*)/.exec(s);
  if (!m) return;
  var want = decodeURIComponent(m[1]).toLowerCase();
  var cur = (document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];

  var target = null;
  if (want === 'en' && cur !== 'en') target = window.tsEnRoot;
  else if (want === 'ja' && cur === 'en') target = window.tsJaRoot;
  if (!target) return;

  // 今の言語のルート（/ や /en）を外したパスを、送り先のルートに付け替える
  var here = window.tsRoot || '/';
  var path = window.location.pathname;
  var rest = path;
  if (here !== '/' && (path === here || path.indexOf(here + '/') === 0)) rest = path.slice(here.length);
  if (rest === '' || rest === '/') rest = '';
  var dest = (target === '/' ? '' : target.replace(/\/$/, '')) + rest;
  if (dest === '') dest = '/';

  // lang だけ取り除いて他のクエリを残す
  var q = s.replace(/^\?/, '').split('&').filter(function (kv) {
    return kv !== '' && kv.split('=')[0] !== 'lang';
  }).join('&');

  window.location.replace(dest + (q ? '?' + q : '') + window.location.hash);
})();
